export const botString = {
  "0": "",
  "1": "qqfile",
  "2": "aotem",
  "3": "jiematop",
  "4": "uujie",
  "5": "safsadf",
  "6": "deanignitenations",
  "7": "kodexfiles2",
  "8": "lunindiacipoksupretto",
  "9": "paniang",
  "10": "ryumasepongmilku",
  "11": "fileshubro",
  "12": "filespanindo",
  "13": "hijautebal",
  "14": "kodexchatsind",
  "15": "massfilesstore",
  // "14": "steviarchiver",
  "16": "fileleak",
  // "17": "fileleakcode",
  "18": "fileport",
  // "18": "jsfile",
  "19": "kfcmnb",
  "20": "lockhive",
  "21": "lockhivecode",
  // "22": "messenger",
  "23": "palucode",
  "24": "siren",
  // "25": "tebiejie",
  "26": "xiumi",
  "27": "wenjianji",
  "28": "zyxfiles",
  // "29": "test",
};